import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden" data-id="element-112">
      {/* Marble Background Image */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/rL7dK7UH3wwQa67MzLqofL/textura-de-marmol-blanco-y-dorado-natural-para-tapiceria-tela-piel-fondo-lujo-interiores-paredes-arte-ceramica-piedra-creativa-268157195.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-113"></div>
      {/* Shimmer Overlay */}
      <div className="absolute inset-0 animate-gold-shimmer mix-blend-overlay opacity-30 pointer-events-none bg-gradient-to-br from-[#D4AF37]/10 via-transparent to-[#D4AF37]/10" data-id="element-114"></div>

      {/* Vignette Overlay */}
      <div className="absolute inset-0 vignette-overlay pointer-events-none" data-id="element-115"></div>

      {/* Floating Gold Dust Particles */}
      <div className="absolute top-1/4 left-1/4 w-2 h-2 rounded-full bg-[#D4AF37] blur-[1px] animate-float opacity-60" data-id="element-116"></div>
      <div className="absolute top-1/3 right-1/4 w-1.5 h-1.5 rounded-full bg-[#F0D060] blur-[1px] animate-float-delayed opacity-50" data-id="element-117"></div>
      <div className="absolute bottom-1/3 left-1/3 w-2.5 h-2.5 rounded-full bg-[#B8860B] blur-[1px] animate-float-slow opacity-40" data-id="element-118"></div>
      <div className="absolute bottom-1/4 right-1/3 w-1 h-1 rounded-full bg-[#D4AF37] blur-[0.5px] animate-float opacity-70" data-id="element-119"></div>

      {/* Large Faint Monogram Watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden" data-id="element-120">
        <span className="font-serif text-[40vw] leading-none text-[#D4AF37] opacity-[0.04] select-none" data-id="element-121">
          IO
        </span>
      </div>

      <div className="relative z-10 w-full max-w-5xl px-4 py-12 md:py-20" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="glass-card rounded-3xl p-8 md:p-16 lg:p-20 flex flex-col items-center text-center relative" data-id="element-123">
          {/* Decorative Corners */}
          <svg className="absolute top-6 left-6 w-4 h-4 text-[#D4AF37] opacity-60" viewBox="0 0 24 24" fill="currentColor" data-id="element-124">
            <path d="M12 0L15.5 8.5L24 12L15.5 15.5L12 24L8.5 15.5L0 12L8.5 8.5L12 0Z" data-id="element-125" />
          </svg>
          <svg className="absolute top-6 right-6 w-4 h-4 text-[#D4AF37] opacity-60" viewBox="0 0 24 24" fill="currentColor" data-id="element-126">
            <path d="M12 0L15.5 8.5L24 12L15.5 15.5L12 24L8.5 15.5L0 12L8.5 8.5L12 0Z" data-id="element-127" />
          </svg>
          <svg className="absolute bottom-6 left-6 w-4 h-4 text-[#D4AF37] opacity-60" viewBox="0 0 24 24" fill="currentColor" data-id="element-128">
            <path d="M12 0L15.5 8.5L24 12L15.5 15.5L12 24L8.5 15.5L0 12L8.5 8.5L12 0Z" data-id="element-129" />
          </svg>
          <svg className="absolute bottom-6 right-6 w-4 h-4 text-[#D4AF37] opacity-60" viewBox="0 0 24 24" fill="currentColor" data-id="element-130">
            <path d="M12 0L15.5 8.5L24 12L15.5 15.5L12 24L8.5 15.5L0 12L8.5 8.5L12 0Z" data-id="element-131" />
          </svg>

          {/* Location Pill */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="inline-flex items-center px-4 py-1.5 rounded-full bg-white/40 border border-[#D4AF37]/40 backdrop-blur-md mb-8" data-id="element-132">
            <span className="font-serif text-sm tracking-widest text-[#5C3D2E] uppercase" data-id="element-133">
              Rosario · Santa Fe · Argentina
            </span>
          </motion.div>

          {/* Main Headline */}
          <div className="relative w-full flex flex-col items-center mb-8" data-id="element-134">
            <div className="w-48 h-48 md:w-60 md:h-60 rounded-full overflow-hidden shadow-[0_0_24px_rgba(212,175,55,0.25)] bg-white flex items-center justify-center" data-id="element-135">
              <img src="https://cdn.magicpatterns.com/uploads/teNZStBa6kH2mSchZ7TZHJ/WhatsApp_Image_2026-05-03_at_17.50.39.jpg" alt="Iara Oliver Academy & Clinic" className="w-[115%] h-[115%] object-cover object-center" data-id="element-136" />
            </div>
          </div>

          {/* Subheadline */}
          <div className="flex flex-col space-y-2 mb-8" data-id="element-137">
            <h2 className="text-sm md:text-lg font-light text-[#5C3D2E] tracking-[0.3em] uppercase" data-id="element-138">
              Micropigmentación · Cejas · Labios
            </h2>
            <h2 className="text-sm md:text-lg font-light text-[#5C3D2E] tracking-[0.3em] uppercase" data-id="element-139">
              Pestañas · Henna · Diseño Consciente
            </h2>
          </div>

          {/* Body Text */}
          <p className="font-serif italic text-[15px] text-[#7A5C4F] max-w-md mb-12" data-id="element-140">
            Más de 6 años transformando miradas con diseño personalizado en
            Rosario
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto" data-id="element-141">
            <motion.a href="https://eyebrowsiaraoliver.site.agendapro.com/ar/sucursal/34777" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} className="animate-breathe w-full sm:w-auto px-8 py-4 rounded-full bg-gold-gradient text-white font-medium tracking-wide shadow-[0_4px_20px_rgba(212,175,55,0.4)] transition-all hover:shadow-[0_6px_25px_rgba(212,175,55,0.5)] text-center" data-id="element-142">
              Reservar Turno →
            </motion.a>
            <motion.a href="#ubicacion" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.98
          }} className="animate-breathe w-full sm:w-auto px-8 py-4 rounded-full bg-transparent border-[1.5px] border-[#D4AF37] text-[#2C1810] font-medium tracking-wide transition-all hover:bg-gold-gradient hover:text-white hover:border-transparent text-center" data-id="element-143">
              Ver Ubicación 📍
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}